import OpcionValoresForm from './OpcionValoresForm.vue';
import SelectorUnidadesProductoLote from './SelectorUnidadesProductoLote.vue';

export default {
  install: (app, _options) => {
    app.component('TiendasOpcionValoresForm', OpcionValoresForm);
    app.component('TiendasSelectorUnidadesProductoLote', SelectorUnidadesProductoLote);
  },
};
